import { render, staticRenderFns } from "./CertificatesFilter.vue?vue&type=template&id=e6b028c0&scoped=true"
import script from "./CertificatesFilter.vue?vue&type=script&lang=js"
export * from "./CertificatesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b028c0",
  null
  
)

export default component.exports